import { useFormikContext } from 'formik'
import { get } from 'lodash'
import { useMemo } from 'react'
import { useDebounce } from 'react-use'

export const ErrorMessage = ({ name, onErrorChange }) => {
	const { errors, values } = useFormikContext()

	const error = useMemo(() => (name ? get(errors, name) : errors), [name, errors])

	useDebounce(
		() => {
			onErrorChange(error)
		},
		300,
		[error, values]
	)

	return null
}
